module.exports = __webpack_public_path__ + "img/souso_bg.6dbc1767.png";